import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CodeOutlined } from "@ant-design/icons";
import { Button, Popover, Table } from "antd";
import { Trans } from "@devowl-wp/react-frontend";
import { useTranslation } from "../../../../../../others/i18n.js";
const ServiceVariablesTip = ()=>{
    const { t } = useTranslation();
    const columns = [
        {
            title: "Variable",
            dataIndex: "variable",
            key: "variable",
            render: (text)=>/*#__PURE__*/ _jsx("code", {
                    children: text
                })
        },
        {
            title: "Description / Example",
            dataIndex: "description",
            key: "description"
        }
    ];
    const data = [
        {
            key: "0",
            variable: "{{var:adminUrl}}",
            description: "Admin URL of the current host, e.g., https://devowl.io/wp-admin/"
        },
        {
            key: "1",
            variable: "{{var:consumer.providerContact.email}}",
            description: "Provider contact email, e.g., info@devowl.io"
        },
        {
            key: "2",
            variable: "{{var:consumer.providerContact.phone}}",
            description: "Provider contact phone, e.g., +1234567890"
        },
        {
            key: "3",
            variable: "{{var:consumer.providerContact.link}}",
            description: "Provider contact link, e.g., https://devowl.io/contact"
        },
        {
            key: "4",
            variable: "{{var:consumer.privacyPolicyUrl}}",
            description: "Privacy policy URL, e.g., https://devowl.io/privacy"
        },
        {
            key: "5",
            variable: "{{var:consumer.legalNoticeUrl}}",
            description: "Legal notice URL, e.g., https://devowl.io/legal"
        },
        {
            key: "6",
            variable: "{{var:consumer.provider}}",
            description: "Provider name, e.g., devowl.io Gmbh"
        },
        {
            key: "7",
            variable: "{{var:consumer.host.main}}",
            description: "Main host, e.g., devowl.io"
        },
        {
            key: "8",
            variable: "{{var:consumer.host.main+subdomains}}",
            description: "Main host with subdomains, e.g., *.devowl.io"
        },
        {
            key: "9",
            variable: "{{var:consumer.host.current}}",
            description: "Current host, e.g., app.devowl.io"
        },
        {
            key: "10",
            variable: "{{var:consumer.host.current+protocol}}",
            description: "Current host with protocol, e.g., https://app.devowl.io"
        },
        {
            key: "11",
            variable: "{{var:consumer.host.current+subdomains}}",
            description: "Current host with subdomains, e.g., *.app.devowl.io"
        }
    ];
    return /*#__PURE__*/ _jsx(Popover, {
        placement: "left",
        title: t("Template variables"),
        content: /*#__PURE__*/ _jsxs(Trans, {
            children: [
                "The following variables can be used in ",
                /*#__PURE__*/ _jsx("strong", {
                    children: "all"
                }),
                " ",
                /*#__PURE__*/ _jsx("code", {
                    children: "string"
                }),
                " values of the service template. They get automatically replaced with the appropriate value:",
                /*#__PURE__*/ _jsx("br", {}),
                /*#__PURE__*/ _jsx("br", {}),
                /*#__PURE__*/ _jsx(Table, {
                    columns: columns,
                    dataSource: data,
                    pagination: false,
                    size: "small"
                })
            ]
        }),
        children: /*#__PURE__*/ _jsx(Button, {
            type: "link",
            icon: /*#__PURE__*/ _jsx(CodeOutlined, {}),
            children: t("Variables")
        })
    });
};
export { ServiceVariablesTip };
